export const Modal = {
  baseStyle: {
    overlay: {
      bg: "blackAlpha.700",
    },
  },
}
